import invariant from 'tiny-invariant'
import type { TypeLiteral } from '../types'

/**
 * Asserts that the value is of the expected type, with a helpful error message.
 *
 * @param value - The value to assert.
 * @param expectedType - The expected type.
 * @param name - The name of the value to use in the error message.
 *
 * @example
 * ```ts
 * invariantType(foo.bar, 'string', 'bar')
 * ```
 */
export function invariantType<T extends TypeLiteral>(
  value: unknown,
  expectedType: T,
  name: string
): asserts value is T {
  invariant(typeof value === expectedType, `${name} must be a \`${expectedType}\` (got \`${typeof value}\`)`)
}
